import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './modal.styl'
import { FormattedMessage } from 'react-intl'

export default class ModalCTA extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    noHeader: PropTypes.bool,
    titleKey: PropTypes.string,
    title: PropTypes.string,
    onClose: PropTypes.func,
    noClose: PropTypes.bool,
  }

  handleClose = () => this.props.onClose()
  renderTitle() {
    const { titleKey, title } = this.props

    if (titleKey) {
      return (
        <FormattedMessage
          id={titleKey}
          defaultMessage={typeof title === 'string' ? title : ''}
        />
      )
    }
    return title
  }

  render() {
    const { noHeader, noClose } = this.props

    return (
      <div className={styles.cta}>
        {!noHeader &&
          <div className={styles.ctaHeader}>
            <h2 className={styles.ctaTitle}>
              {this.renderTitle()}
            </h2>
            <i
              className={`ico ico--close ${styles.ctaHeaderClose}`}
              onClick={this.handleClose}
            />
          </div>}
        {noHeader &&
          !noClose &&
          <i
            className={`ico ico--close ${styles.ctaHeaderClose}`}
            onClick={this.handleClose}
          />}
        <div className={styles.ctaContent}>
          {this.props.children}
        </div>
      </div>
    )
  }
}
